import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import themeColor from '../theme/themeOverride';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import SuccessIcon from './svg/SuccessIcon';

const useStyles = makeStyles((theme: any) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 1.5, 1.5, 1.5),
    },
    backgroundColor: theme.palette.success.light,
    borderColor: themeColor.palette.success['500'],
    width: '100%',
    padding: theme.spacing(1),
  },
  message: {
    fontSize: 13,
    fontWeight: 400,
  },
  subMessage: {
    color: theme.palette.grey['100'],
    fontSize: 12,
  },
  alertIcon: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

type Props = {
  message: string;
};

const AlertSuccess = (props: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.root} border={2} borderRadius='borderRadius' display='flex' alignItems='flex-start'>
      <SuccessIcon className={classes.alertIcon} viewBox='0 0 26 26' />
      <Box>
        <Typography className={classes.message} variant='body1'>
          {props.message}
        </Typography>
      </Box>
    </Box>
  );
};

AlertSuccess.defaultProps = {
  subMessage: null,
};

export default AlertSuccess;
